
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ahxwbmguupqmonzobezy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFoeHdibWd1dXBxbW9uem9iZXp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc1Nzk5MDUsImV4cCI6MjA2MzE1NTkwNX0.NG1Er_dpUQGdQNfP2CQABlRHQGmSQmpuGmsR8Qobaf8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
